<div class="tabs_container_flightDetails" aria-live="assertive">
  <div class="tabsHeader" role="tablist" aria-label="Flight details">
    <div
      class="tab_base"
      [ngClass]="{'tab_select': selectedTab === TabType.FareDetails}"
      (click)="selectedTab = TabType.FareDetails"
      (keydown.enter)="selectedTab = TabType.FareDetails"
      tabindex="0"
      role="tab"
      [attr.aria-selected]="selectedTab === TabType.FareDetails"
      [attr.aria-controls]="'flight-details-fare-panel-' + flightIndex"
      id="flight-details-fare-details-{{flightIndex}}"
    >
      <span i18n="@@itemDetailsFaredetails"> Fare Details </span>
      <span class="visuallyhidden"> - {{visuallyHiddenLabel}}</span>
    </div>
    <div
      class="tab_base"
      [ngClass]="{'tab_select': selectedTab === TabType.FlightLegTimes}"
      (keydown.enter)="selectedTab = TabType.FlightLegTimes"
      (click)="selectedTab = TabType.FlightLegTimes"
      tabindex="0"
      role="tab"
      [attr.aria-selected]="selectedTab === TabType.FlightLegTimes"
      [attr.aria-controls]="'flight-details-show-panel-' + flightIndex"
      id="flight-details-show-details-{{flightIndex}}"
    >
      <span i18n="@@itemDetailsFlightLegTimes"> Show Details </span>
      <span class="visuallyhidden"> - {{visuallyHiddenLabel}}</span>
    </div>
  </div>
  @if (selectedTab === TabType.FareDetails) {
  <div
    class="pane"
    role="tabpanel"
    [attr.aria-labelledby]="'flight-details-fare-details-' + flightIndex"
    id="flight-details-fare-panel-{{flightIndex}}"
    i18n-Title
  >
    <div class="ticketScroll">
      <ng-container>
        <app-fares-table
          (selectedMultiCityFlight)="selectedMultiCityFlight.emit($event);"
          (deselectMultiCityFlight)="deselectMultiCityFlight.emit($event)"
          [selectedItemsId]="selectedItemsId"
          [disableItems]="disableItems"
          [isExchange]="isExchange"
          [isPricingExchange]="isPricingExchange"
          [isMultiCity]="searchParams.chosenSearchType === FlightSearchType.multiCity || flightDetail.additional?.isExchangeMultiCityItinerary"
          [isDualFlight]="isDualFlight"
          [isDualReturn]="isDualReturn"
          (addToBasketEvent)="addToBasket($event)"
          [isTravelfusion]="isTravelfusion"
          [fares]="fares"
          [searchParams]="searchParams"
          [showFaresBlock]="true"
          [isUnavailableDueToTime]="isUnavailableDueToTime"
        ></app-fares-table>
      </ng-container>
    </div>
  </div>
  } @if (selectedTab === TabType.FlightLegTimes) {
  <div
    class="pane"
    role="tabpanel"
    [attr.aria-labelledby]="'flight-details-show-details-' + flightIndex"
    id="flight-details-show-panel-{{flightIndex}}"
  >
    <div class="leg_wrapper">
      <div class="leg_container">
        <app-routehappy [flight]="flightDetails"></app-routehappy>
        <app-flight-legs
          [legs]="flightDetail.outboundFlights"
          [flight]="flightDetail"
          [isMultiCity]="searchParams.chosenSearchType === FlightSearchType.multiCity || flightDetail.additional?.isExchangeMultiCityItinerary"
          [flightIndex]="flightIndex"
        >
        </app-flight-legs>
        @if (flightDetail.inboundFlights.length) {
        <div>
          <app-flight-legs
            [legs]="flightDetail.inboundFlights"
            [flight]="flightDetail"
            [isReturn]="true"
            [isMultiCity]="searchParams.chosenSearchType === FlightSearchType.multiCity || flightDetail.additional?.isExchangeMultiCityItinerary"
            [flightIndex]="flightIndex"
          >
          </app-flight-legs>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
